import {Box, Typography} from '@mui/material';
import './ViewManageAssignments.scss';
import ArrTooltipWrapper from '../common/arr-tooltip-wrapper/ArrTooltipWrapper';
import {t} from 'i18next';
import {ReactComponent as InfoIcon} from '../../assets/images/info-icon.svg';
import {useState} from 'react';
import ArrSplitPanel from '../common/arr-split-panel/ArrSplitPanel';
import AssignmentsDataGrid from './assignments-data-grid/AssignmentsDataGrid';
import ManageAssignmentsTree from './manage-assignments-tree/ManageAssignmentsTree';
import {ArrToggle} from '../common/arr-toggle/ArrToggle';

const shortInfo = () => (
  <>
    <p data-testid={`view-manage-assignments-tt0`}>
      {t('assignment.tooltip.tt0')}
    </p>
    <a
      href="https://www.sightlinecentral.com/documentation/coding-conflicts-and-bulk-tagging/"
      target="_blank"
      rel="noopener noreferrer"
      className="manage-assignment-link"
      data-testid={`view-manage-assignments-tt01`}
    >
      {t('assignment.tooltip.tt01')}
    </a>
    <br data-testid={`view-manage-assignments-br`} />
    <h3 data-testid={`view-manage-assignments-tt1`}>
      {t('assignment.tooltip.tt1')}
    </h3>
    <p data-testid={`view-manage-assignments-tt2`}>
      {t('assignment.tooltip.tt2')}
    </p>
    <p data-testid={`view-manage-assignments-tt3`}>
      {t('assignment.tooltip.tt3')}
    </p>
    <br data-testid={`view-manage-assignments-br-btn`} />
    <h3 data-testid={`view-manage-assignments-tt4`}>
      {t('assignment.tooltip.tt4')}
    </h3>
    <p data-testid={`view-manage-assignments-tt5`}>
      {t('assignment.tooltip.tt5')}
    </p>
    <p data-testid={`view-manage-assignments-tt6`}>
      {t('assignment.tooltip.tt6')}
    </p>
    <br data-testid={`view-manage-assignments-br-button`} />
  </>
);

const ViewManageAssignments = () => {
  const [isToggleActive, setIsToggleActive] = useState(false);
  const [assignmentGroupId, setAssignmentGroupId] = useState<string | null>(
    null
  );

  const handleActionToggle = (status: boolean) => {
    setIsToggleActive(status);
  };
  const getAssignmentGroupId = (itemId: string) => {
    setAssignmentGroupId(itemId);
  };

  const leftPanel = () => (
    <Box className="assignment-treeview-container">
      <Box className="treeview-header">
        <Typography
          className="typo-text subhead4_size saved-search-title-text"
          data-testid={`view-manage-assignments-assignment-group`}
        >
          {t('assignment.assignmentGroup')}
        </Typography>
        <Box className="treeview-sub">
          <Typography
            className="typo-text body5_size"
            data-testid={`view-manage-assignments-toggle-button-title`}
          >
            {t('assignment.toggleButtonTitle')}
          </Typography>
          <Box className="toggle-button" data-testid="toggle-button">
            <ArrToggle
              value={isToggleActive}
              size="medium"
              onChange={(e) => handleActionToggle(e.target.checked)}
              dataTestId="manage-assignment-action-toggle"
            />
          </Box>
        </Box>
      </Box>
      <Box>
        <ManageAssignmentsTree
          isToggleActive={isToggleActive}
          getAssignmentGroupId={getAssignmentGroupId}
        />
      </Box>
    </Box>
  );

  const rightPanel = () => (
    <Box className="assignment-grid-container">
      <AssignmentsDataGrid assignmentGroupId={assignmentGroupId} />
    </Box>
  );

  return (
    <Box className="manage-assignments-main">
      <Box className="manage-assignments-header">
        <Box className="manage-assignments-title">
          <Box className="manage-assignments-title">
            <Typography
              className="typo-text headline3_size assignment-title-text"
              data-testid={`view-manage-assignments-title`}
            >
              {t('assignment.title')}
            </Typography>
            <ArrTooltipWrapper
              title={t('assignment.tooltip.title')}
              trigger={
                <InfoIcon
                  fontSize="medium"
                  className="saved-search-info-icon"
                  data-testid="manage-assignment-info-icon"
                />
              }
            >
              {shortInfo()}
            </ArrTooltipWrapper>
          </Box>
        </Box>
      </Box>
      <Box className="manage-assignment-container">
        <ArrSplitPanel leftPanel={leftPanel()} rightPanel={rightPanel()} />
      </Box>
    </Box>
  );
};

export default ViewManageAssignments;
